export var Event;
(function (Event) {
    Event["Answer"] = "answer";
})(Event || (Event = {}));
